import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticatedGuard } from './guards/authenticated.guard';
import { NotAuthenticatedGuard } from './guards/not-authenticated.guard';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthenticatedGuard],
    loadChildren: () => import('./pages/root/root.module').then(m => m.RootModule),
    data: {
      ownTemplate: true
    }
  },
  {
    path: 'login',
    canActivate: [NotAuthenticatedGuard],
    loadChildren: () => import('./pages/authenticate-page/authenticate-page.module').then(m => m.AuthenticatePageModule),
    data: {
      ownTemplate: true
    }
  },
  {
    path: 'restore',
    canActivate: [NotAuthenticatedGuard],
    loadChildren: () => import('./pages/restore-password/restore-password.module').then(m => m.RestorePasswordModule),
    data: {
      ownTemplate: true
    }
  },

  // service pages
  {
    path: 'forbidden',
    loadChildren: () => import('./pages/forbidden/forbidden.module').then(m => m.ForbiddenModule)
  },
  {
    path: 'not-found',
    loadChildren: () => import('./pages/not-found/not-found.module').then(m => m.NotFoundModule)
  },
  {
    path: '**',
    loadChildren: () => import('./pages/not-found/not-found.module').then(m => m.NotFoundModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
